import React from 'react';
import { Link } from 'react-router';

import './ContactDoctors.scss';

import doctorsImgs from '../../../assets/img/llc/doctors/';

class DoctorsList extends React.PureComponent {
    renderDoctors = () => {
        const branchActive = this.props.branchActive;
        const doctors = this.props.langs.doctors.filter(doctor => {
            return doctor.branches.includes(branchActive)
        });


        return doctors.map((doctor) => {
            return (
                <div
                    className="col-6 contactDoctors_item_col"
                    key={doctor.id}
                >
                    <div className="contactDoctors_item">
                        <div className="contactDoctors_item_img"><img src={doctorsImgs[doctor.photoId]}/></div>
                        <div className="contactDoctors_item_text">
                            <div className="contactDoctors_item_name">{doctor.name}</div>
                            <Link to={"lekar/" + doctor.id} className="contactDoctors_item_btn">Karta lékaře</Link>
                        </div>
                    </div>
                </div>
            )
        });
    };

    render() {
        return (
            <section className="contactDoctors">
                <div className="contactDoctors_top">
                    <div className="container">
                        <h6 className="line">Pobočka Kliniky LLC</h6>
                        <div className="contactDoctors_top_text">
                            Pod vedením <strong>MUDr. Igora Janíka, Ph.D.</strong>, jednoho z nejzkušenějších odborníků
                            na laserovou léčbu, estetickou a žilní chirurgii, o pacienty v Laserovém
                            léčebném centru pečují:
                        </div>
                    </div>
                </div>

                <div className="contactDoctors_wrap">
                    <div className="container">
                        <div className="row contactDoctors_row">
                            {this.renderDoctors()}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default DoctorsList;


// WEBPACK FOOTER //
// ./src/components/Contact/ContactDoctors/ContactDoctors.js